// QrScannerSection.tsx
import React, { useState } from "react";
import { Button, Center, Stack, Text, Popover } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { Scanner, IBoundingBox, IPoint } from "@yudiel/react-qr-scanner";
import { IconQrcode } from "@tabler/icons-react";

export interface IDetectedBarcode {
  boundingBox: IBoundingBox;
  cornerPoints: IPoint[];
  format: string;
  rawValue: string;
}

interface Props {
  onDetected: (raw: string) => void;
}

const QrScannerSection: React.FC<Props> = ({ onDetected }) => {
  const [active, setActive] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const handleScan = (codes: IDetectedBarcode[]) => {
    if (codes.length && codes[0]?.rawValue) {
      onDetected(codes[0].rawValue);
      setActive(false);
    }
  };

  return (
    <>
      <Button
        variant="filled"
        color="blue"
        aria-label="scan QR code"
        onClick={() => setActive((v) => !v)}
        leftSection={<IconQrcode size={16} />}
      >
        {active ? "Close Scanner" : "Scan QR Code"}
      </Button>
      {!isMobile && active && (
        <Text size="xs" c="dimmed" ta="center" mt="xs">
          QR scanning requires camera permission and works best on mobile
          browsers.
        </Text>
      )}
      {isMobile && active && (
        <Popover width={280} position="top" withArrow shadow="md">
          <Popover.Target>
            <Text
              size="xs"
              c="blue"
              ta="center"
              mt="xs"
              style={{ textDecoration: "underline", cursor: "pointer" }}
            >
              On Graphene OS?
            </Text>
          </Popover.Target>
          <Popover.Dropdown>
            <Text size="xs">
              Graphene OS users usually have to manually enable "JavaScript JIT"
              for Rizful.com to allow usage of the camera.
            </Text>
          </Popover.Dropdown>
        </Popover>
      )}
      {active && <Scanner onScan={handleScan} sound={false} />}
    </>
  );
};

export default QrScannerSection;
